import { Card } from '@yleisradio/areena-types';
import { CardLabels } from 'components/Card/CardLabels';
import { Container } from 'components/Container';
import { Link } from 'components/Link';
import Image from 'next/image';
import * as React from 'react';
import { filterLabelsByType } from 'utils/card';
import {
  heroBackgroundImageLoader,
  loaderUrl,
  squareImageLoader,
} from 'utils/cloudinary';
import { sanitizeHtmlId } from 'utils/ui-helpers';
import styles from './HeroCard.module.scss';
import { HeroControls } from './HeroControls';
import { GridContainer, GridElement } from 'components/Grid';

type Props = {
  card: Card;
  cardKey: string;
};

export const HeroCard: React.FunctionComponent<Props> = ({ card, cardKey }) => {
  const headingId = sanitizeHtmlId(cardKey + 'title');
  const highlightLabels = filterLabelsByType('highlight', card.labels);
  const controls = card.controls || [];

  return (
    <div className={styles.root} role="group" aria-labelledby={headingId}>
      {card.image && (
        <div className={styles.backgroundImage}>
          <Image
            alt=""
            src={loaderUrl(card.image)}
            loader={heroBackgroundImageLoader}
            priority
            fill
            sizes="100vw"
            style={{ objectFit: 'cover' }}
          />
        </div>
      )}

      <Container>
        <GridContainer>
          <GridElement mobile={2} mobileLandscape={0} />

          <GridElement mobile={8} mobileLandscape={4} desktop={6}>
            <div className={styles.image}>
              {card.image && (
                <Image
                  alt=""
                  src={loaderUrl(card.image)}
                  loader={squareImageLoader}
                  priority
                  fill
                  sizes="(min-width: 1400px) 22.5vw, (min-width: 480px) 30vw, 60vw"
                />
              )}
            </div>
          </GridElement>

          <GridElement mobile={2} mobileLandscape={0} />

          <GridElement mobile={12} mobileLandscape={8}>
            <div className={styles.textContent}>
              {highlightLabels.length > 0 && (
                <div className={styles.highlightLabels}>
                  <CardLabels labels={highlightLabels} isHighlight />
                </div>
              )}

              <h3 className={styles.title} id={headingId}>
                {card.pointer ? (
                  <Link pointer={card.pointer} className={styles.link}>
                    {card.title}
                  </Link>
                ) : (
                  card.title
                )}
              </h3>

              {card.description ? (
                <p className={styles.description}>{card.description}</p>
              ) : null}

              {controls.length > 0 && (
                <div className={styles.controls}>
                  <HeroControls controls={controls} />
                </div>
              )}
            </div>
          </GridElement>
        </GridContainer>
      </Container>
    </div>
  );
};
